import * as Backend from './BackendRequest';

export const GetGeneralOptions = () => Backend.request('GET', '/options');

export const GetStudyOptions = () => Backend.request('GET', '/programmes');
